<div [className]="className" *ngIf="message !== undefined && message!==''">
  {{message}}
</div>
